<template>
  <v-card
    class="mb-2 grey lighten-4"
    @programar-bio-aleatoria="programarBioAleatoria"
  >
    <v-card-text
      class="headline font-weight-bold"
      justify="center"
      align="center"
    >
      <div id="livechat" style="height: 60vh" />
    </v-card-text>
  </v-card>
</template>

<script>
import cfc from "@/ws/cfc";
import aulasTeorica from "@/ws/aulasTeorica";

export default {
  props: {
    linkMeet: {
      type: String,
    },
    tempObjMeet: {
      type: Object
    },
    domain: {
      type: String
    },
    jitsiExternalScript: {
      type: String
    },
    jwt: {
      type: String
    }
  },
  data() {
    return {
      apiMeet: '',
      tempoRestante: 5,
      quantBioNecessaria: 1,
      quantBioTiradas: 0,
      hasBioReturn: false,
      funcao: null,
      quantBioTiradas: parseInt(localStorage.getItem('quantBioTiradas')) || 0,
      timeoutIds: [],
      user: {
        nome: '',
        email: 'user.email@gmail.com'
      },
      cargaHoraria: 0,

    }
  },
  created() {
    this.loadJitsiAPI();
    if(this.tempObjMeet.status != 4){
        localStorage.removeItem('intervalos'); 
    }
  },
  mounted() {
    this.setInfoUser();
    this.startConference();
    this.setSubject();
    this.quantBioTiradas = parseInt(localStorage.getItem('quantBioTiradas')) || 0;
    this.$parent.$on('programar-bio-aleatoria', this.programarBioAleatoria);
    this.$parent.$on('cancelar-capturas', this.cancelarCapturas);
  },
  methods: {
    loadJitsiAPI() {
      // TODO encontrar uma forma de checar se o carregamento deu certo
      let externalScript = document.createElement('script')
      externalScript.setAttribute('src', this.jitsiExternalScript)
      document.head.appendChild(externalScript)
    },

    setInfoUser() {
      this.user.nome = this.$store.getters.getAluno.nome ? this.$store.getters.getAluno.nome : 'Aluno';
    },

    startConference() {
      var domain = this.domain;
      try {
        const options = {
          roomName: this.linkMeet,
          jwt: this.jwt,
          width: '100%',
          height: '100%',
          parentNode: document.getElementById('livechat'),
          configOverwrite: {
            defaultLanguage: 'ptBR',
            startWithAudioMuted: true,
            prejoinPageEnabled: false,
            disableInviteFunctions: true,
            toolbarButtons: ['chat', 'raisehand', 'camera', 'microphone'],
          },
          interfaceConfigOverwrite: {LANG_DETECTION: false},
        };
        // eslint-disable-next-line no-undef
        this.apiMeet = new JitsiMeetExternalAPI(domain, options);

        // Emitir a referência da API para o componente pai
        this.$emit('apiMeetInitialized', this.apiMeet);
      } catch (error) {
        console.log(error);
      }
      this.startRandomCounter();
    },

    setSubject() {
      this.apiMeet.executeCommand('subject', 'Aula Teórica');
    },

    startRandomCounter() {
      this.getTempo().then(() => {
        this.getCalculoTempo().then(() => {
          this.getBiometriasTiradas().then(() => {
            this.getCargaHoraria().then(() => {
              this.programarBioAleatoria();
            });
          });
        });
      });
    },

    getTempo() {
      return aulasTeorica.getTempoAula(this.tempObjMeet.id)
        .then(response => {
          this.tempoRestante = response.data.message;
        }).catch(erro => {
          console.log('erro getTempo', erro);
          this.tempoRestante = 15;
        });
    },

    getCargaHoraria() {
      return aulasTeorica.find(this.tempObjMeet.id)
        .then(response => {
          this.cargaHoraria = response.data[0].duracao
        }).catch(erro => {
          console.log('erro getCalculoTempo', erro);
        });
    },

    getCalculoTempo() {
      return cfc.getQuantidadeBiometria()
        .then(response => {
          this.quantBioNecessaria = response.data.quantidade_biometria
        }).catch(erro => {
          console.log('erro getCalculoTempo', erro);
        });
    },


    getBiometriasTiradas() {
      return aulasTeorica.getNumeroBiometriasTiradas(this.tempObjMeet.id, this.$store.getters.getAluno.id, '1')
        .then(response => {
          this.quantBioTiradas = response.data.biometrias;
        }).catch(erro => {
          console.log('erro getBiometriasTiradas', erro);
        });
    },
    programarBioAleatoria() {
      if (this.$store.getters.getCfc.uf == "MT") {
        const aulaEmAndamento = this.tempObjMeet.status == 4;
        const aulaEmIntervalo = this.tempObjMeet.status == 8;
        
      if (aulaEmIntervalo) {
        this.cancelarCapturas(); 
        return;
      }
     
      if (aulaEmAndamento) {
        console.log('Aula em andamento ou em intervalo, programando biometrias aleatórias...');
      }else{
        return;
      }

      this.$emit('agendar-intervalo'); // Emite o evento para o componente pai

      // Aguarda os horários de captura serem enviados de volta pelo componente pai
      this.$parent.$on('horarios-captura', (horariosCaptura) => {
        this.agendarCapturas(horariosCaptura);
      });
    }
  },

  agendarCapturas(horariosCaptura) {
    const agora = new Date();
    horariosCaptura.forEach(horario => {
      const [h, m, s] = horario.split(':').map(Number);
      const horarioDate = new Date(agora);
      horarioDate.setHours(h, m, s, 0);
      const tempoRestante = horarioDate - agora;

      if (tempoRestante > 0) {
        const timeoutId = setTimeout(() => {
          document.dispatchEvent(new CustomEvent('carregaModal'));
        }, tempoRestante);
        this.timeoutIds.push(timeoutId);
      }
    });
  },
  cancelarCapturas() {
    this.timeoutIds.forEach(timeoutId => clearTimeout(timeoutId));
    this.timeoutIds = []; 
  },
    getRandomNumber(min, max) { 
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    getRandomNumberSimple(maximo) {
      return Math.floor(Math.random() * (maximo - 1 + 1) + 1);
    }
  }
}
</script>